@if (enableNetworkStatusIndicator) {
  <div
    class="network-status-indicator"
    [class.offline]="!isOnline"
    [class.online]="isOnline && !isUnstable"
    [class.unstable]="isOnline && isUnstable"
    nz-tooltip
    [nzTooltipTitle]="getTooltipText()"
    nzTooltipPlacement="bottom"
  >
    <span nz-icon [nzType]="getIconType()" nzTheme="outline"></span>
    <span class="status-text">{{ getStatusText() }}</span>
  </div>
}
